function getCustomHeaderHeight(){
    const customNavbar=document.querySelector('.custom-navbar');
    const breadcrumb=document.querySelector('.breadcrumb');
    if(!customNavbar || !breadcrumb) {
        console.error('customNavbar or breadcrumb not found');
    }else{
        const customNavbarHeight=customNavbar.clientHeight;
        breadcrumb.style.top=customNavbarHeight+'px';
    }
}

export function initBreadcrumb() {
    getCustomHeaderHeight()
    window.addEventListener('resize',function(){
        getCustomHeaderHeight()
    })
}